import { __assign, __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import { GALLERY_CONSTS, window, utils, isEditMode, isSEOMode, isPreviewMode, isSiteMode, windowWrapper, } from '@wix/pro-gallery-lib-old';
import { ItemsHelper } from '@wix/pro-layouts-old';
import GalleryView from './galleryView';
import SlideshowView from './slideshowView';
import { scrollToItemImp, scrollToGroupImp, haltScroll, } from '../../helpers/scrollHelper';
import ScrollIndicator from './galleryScrollIndicator';
import { createCssLayouts } from '../../helpers/cssLayoutsHelper.js';
import { cssScrollHelper } from '../../helpers/cssScrollHelper.js';
import VideoScrollHelperWrapper from '../../helpers/videoScrollHelperWrapper';
import findNeighborItem from '../../helpers/layoutUtils';
import { isGalleryInViewport, Deferred } from './galleryHelpers';
var GalleryContainer = /** @class */ (function (_super) {
    __extends(GalleryContainer, _super);
    function GalleryContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.updateVisibility = function () {
            var isInViewport = isGalleryInViewport({
                container: _this.props.container,
                scrollTop: _this.state.scrollPosition.top,
            });
            if (_this.state.isInViewport !== isInViewport) {
                _this.setState({
                    isInViewport: isInViewport,
                });
            }
        };
        _this.setVisibilityIfNeeded = function (prevProps, prevState) {
            var container = _this.props.container;
            var scrollPosition = _this.state.scrollPosition;
            if (container.scrollBase !== prevProps.container.scrollBase ||
                scrollPosition.top !== prevState.scrollPosition.top) {
                _this.updateVisibility();
            }
        };
        _this.findNeighborItem = function (itemIdx, dir) {
            return findNeighborItem(itemIdx, dir, _this.state.structure.items);
        }; // REFACTOR BLUEPRINTS - this makes the function in the layouter irrelevant (unless the layouter is used as a stand alone with this function, maybe the layouter needs to be split for bundle size as well...)
        if (utils.isVerbose()) {
            console.count('[OOISSR] galleryContainer constructor', window.isMock);
        }
        _this.getMoreItemsIfNeeded = _this.getMoreItemsIfNeeded.bind(_this);
        _this.setGotFirstScrollIfNeeded = _this.setGotFirstScrollIfNeeded.bind(_this);
        _this.toggleLoadMoreItems = _this.toggleLoadMoreItems.bind(_this);
        _this.scrollToItem = _this.scrollToItem.bind(_this);
        _this.scrollToGroup = _this.scrollToGroup.bind(_this);
        _this._scrollingElement = _this.getScrollingElement();
        _this.eventsListener = _this.eventsListener.bind(_this);
        _this.onGalleryScroll = _this.onGalleryScroll.bind(_this);
        _this.setPlayingIdxState = _this.setPlayingIdxState.bind(_this);
        _this.getVisibleItems = _this.getVisibleItems.bind(_this);
        _this.findNeighborItem = _this.findNeighborItem.bind(_this);
        _this.updateVideoScrollHelperStructure =
            _this.updateVideoScrollHelperStructure.bind(_this);
        _this.setCurrentSlideshowViewIdx =
            _this.setCurrentSlideshowViewIdx.bind(_this);
        _this.getIsScrollLessGallery = _this.getIsScrollLessGallery.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        _this.videoScrollHelper = new VideoScrollHelperWrapper(_this.setPlayingIdxState);
        var initialState = {
            scrollPosition: {
                top: 0,
                left: 0,
            },
            showMoreClickedAtLeastOnce: false,
            initialGalleryHeight: undefined,
            needToHandleShowMoreClick: false,
            gotFirstScrollEvent: props.activeIndex >= 0,
            playingVideoIdx: -1,
            viewComponent: null,
            firstUserInteractionExecuted: false,
            isInHover: false,
            isInViewport: true,
        };
        _this.state = initialState;
        _this.layoutCss = [];
        _this.initialGalleryState = {};
        try {
            var galleryState = _this.propsToState(props);
            if (Object.keys(galleryState).length > 0) {
                _this.initialGalleryState = galleryState;
            }
        }
        catch (_e) {
            console.warn('Cannot create initial state from props', _e);
        }
        _this.state = __assign(__assign({}, initialState), _this.initialGalleryState);
        return _this;
        //not sure if there needs to be a handleNEwGalleryStructure here with the intial state. currently looks like not
    }
    GalleryContainer.prototype.initializeScrollPosition = function () {
        if (this.props.activeIndex > 0) {
            this.scrollToItem(this.props.activeIndex, false, true, 0);
            var currentItem = this.galleryStructure.items[this.props.activeIndex];
            this.onGalleryScroll(currentItem.offset);
        }
    };
    GalleryContainer.prototype.isScrollingUnavailable = function (height, viewportHeight) {
        var extraPadding = 300;
        if (this.isVerticalGallery()) {
            // If here then the vertical scrolling is what matters
            return height <= viewportHeight + extraPadding;
        }
        else {
            // If here it's the horizontal scrolling that matters
            return (this.state.structure.width < this.state.container.width + extraPadding);
        }
    };
    // This function runs if site is scroll-less => tries to fetch gallery's items, -- called from didMount only! --
    GalleryContainer.prototype.getMoreItemsIfScrollIsDisabled = function (height, viewportHeight) {
        return __awaiter(this, void 0, void 0, function () {
            var lastItemsCount_1;
            var _this = this;
            return __generator(this, function (_a) {
                //there can be no scroll to trigger getMoreItems, but there could be more items
                if (this.isScrollingUnavailable(height, viewportHeight)) {
                    lastItemsCount_1 = this.state.items.length;
                    // Trying to get more items
                    this.getMoreItemsIfNeeded(0).then(function () {
                        // No need to continue calling if no items are left to fetch
                        if (_this.state.items.length > lastItemsCount_1) {
                            var body = document.body, html = document.documentElement;
                            var viewportHeight_1 = window.innerHeight;
                            var height_1 = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
                            _this.getMoreItemsIfScrollIsDisabled(height_1, viewportHeight_1);
                        }
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    GalleryContainer.prototype.componentDidMount = function () {
        var scrollHelperNewGalleryStructure = {
            galleryStructure: this.galleryStructure,
            galleryWidth: this.state.container.galleryWidth,
            scrollBase: this.state.container.scrollBase,
            videoPlay: this.state.options.videoPlay,
            videoLoop: this.state.options.videoLoop,
            itemClick: this.state.options.itemClick,
            scrollDirection: this.state.options.scrollDirection,
            cb: this.setPlayingIdxState,
        };
        this.updateVideoScrollHelperStructure(scrollHelperNewGalleryStructure, this.state.items);
        windowWrapper.stopUsingMock();
        var body = document.body, html = document.documentElement;
        var viewportHeight = window.innerHeight;
        var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        this.initializeScrollPosition();
        this.getMoreItemsIfScrollIsDisabled(height, viewportHeight);
        this.handleNewGalleryStructure();
        this.eventsListener(GALLERY_CONSTS.events.APP_LOADED, {});
        this.videoScrollHelper.initializePlayState();
        try {
            if (typeof window.CustomEvent === 'function') {
                this.currentHoverChangeEvent = new CustomEvent('current_hover_change');
            }
            else {
                //IE (new CustomEvent is not supported in IE)
                this.currentHoverChangeEvent =
                    window.document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
                this.currentHoverChangeEvent.initCustomEvent('current_hover_change', false, false, null);
            }
        }
        catch (e) {
            console.error("could not create 'current_hover_change' customEvent. Error =", e);
        }
        if (this.props.id) {
            this.currentHoverChangeEvent.galleryId = this.props.id;
        }
    };
    GalleryContainer.prototype.updateVideoScrollHelperStructure = function (scrollHelperParams, items) {
        this.videoScrollHelper.updateGalleryStructure(scrollHelperParams, !utils.isSSR(), items);
    };
    GalleryContainer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (!this.currentHoverChangeEvent.galleryId && nextProps.id) {
            this.currentHoverChangeEvent.galleryId = nextProps.id;
        }
        if (this.props.activeIndex !== nextProps.activeIndex &&
            nextProps.activeIndex !== this.currentSlideshowViewIdx) {
            this.scrollToItem(nextProps.activeIndex, false, true, 0);
        }
        var reCreateGallery = function () {
            var galleryState = _this.propsToState(nextProps);
            var scrollHelperNewGalleryStructure = {
                galleryStructure: _this.galleryStructure,
                galleryWidth: galleryState.container.galleryWidth,
                scrollBase: galleryState.container.scrollBase,
                videoPlay: galleryState.options.videoPlay,
                videoLoop: galleryState.options.videoLoop,
                itemClick: galleryState.options.itemClick,
                scrollDirection: galleryState.options.scrollDirection,
                cb: _this.setPlayingIdxState,
            };
            _this.updateVideoScrollHelperStructure(scrollHelperNewGalleryStructure, galleryState.items);
            if (Object.keys(galleryState).length > 0) {
                _this.setState(galleryState, _this.handleNewGalleryStructure);
            }
        };
        var getSignificantProps = function (props) {
            var id = props.id, options = props.options, container = props.container, items = props.items, isInDisplay = props.isInDisplay, isPrerenderMode = props.isPrerenderMode;
            return { id: id, options: options, container: container, items: items, isInDisplay: isInDisplay, isPrerenderMode: isPrerenderMode };
        };
        if (this.reCreateGalleryTimer) {
            clearTimeout(this.reCreateGalleryTimer);
        }
        var hasPropsChanged = true;
        try {
            var currentSignificantProps = getSignificantProps(this.props);
            var nextSignificantProps = getSignificantProps(nextProps);
            hasPropsChanged =
                JSON.stringify(currentSignificantProps) !==
                    JSON.stringify(nextSignificantProps);
            if (utils.isVerbose() && hasPropsChanged) {
                console.log('New props arrived', utils.printableObjectsDiff(currentSignificantProps, nextSignificantProps));
            }
        }
        catch (e) {
            console.error('Cannot compare props', e);
        }
        if (hasPropsChanged) {
            reCreateGallery();
            if (this.props.isInDisplay !== nextProps.isInDisplay) {
                this.handleNavigation(nextProps.isInDisplay);
            }
        }
        else {
            //this is a hack, because in fullwidth, new props arrive without any changes
            // this.reCreateGalleryTimer = setTimeout(reCreateGallery, 1000);
        }
    };
    GalleryContainer.prototype.handleNavigation = function (isInDisplay) {
        if (isInDisplay) {
            this.videoScrollHelper.trigger.INIT_SCROLL();
        }
        else {
            this.videoScrollHelper.stop();
        }
    };
    GalleryContainer.prototype.handleNewGalleryStructure = function () {
        //should be called AFTER new state is set
        var _a = this.state, container = _a.container, needToHandleShowMoreClick = _a.needToHandleShowMoreClick, initialGalleryHeight = _a.initialGalleryHeight;
        var isInfinite = this.containerInfiniteGrowthDirection() === 'vertical';
        var updatedHeight = false;
        var needToUpdateHeightNotInfinite = !isInfinite && needToHandleShowMoreClick;
        if (needToUpdateHeightNotInfinite) {
            var showMoreContainerHeight = 138; //according to the scss
            updatedHeight =
                container.height + (initialGalleryHeight - showMoreContainerHeight);
        }
        var options = this.props.options;
        var numOfItems = this.state.items.length;
        var layoutHeight = updatedHeight || this.props.container.height;
        var layoutItems = this.props.structure.items;
        var isFixedHorizontlaGalleryRatio = this.containerInfiniteGrowthDirection() === 'horizontal' &&
            this.state.options.layoutParams.structure.galleryRatio.value > 0;
        var onGalleryChangeData = {
            numOfItems: numOfItems,
            container: container,
            options: options,
            layoutHeight: layoutHeight,
            layoutItems: layoutItems,
            isInfinite: isInfinite,
            isFixedHorizontlaGalleryRatio: isFixedHorizontlaGalleryRatio,
            updatedHeight: updatedHeight,
        };
        if (utils.isVerbose()) {
            console.log('handleNewGalleryStructure', onGalleryChangeData);
        }
        this.eventsListener(GALLERY_CONSTS.events.GALLERY_CHANGE, onGalleryChangeData);
        if (needToHandleShowMoreClick) {
            this.setState({ needToHandleShowMoreClick: false });
        }
    };
    GalleryContainer.prototype.isVerticalGallery = function () {
        return (this.state.options.scrollDirection ===
            GALLERY_CONSTS.scrollDirection.VERTICAL);
    };
    GalleryContainer.prototype.getIsScrollLessGallery = function (options) {
        var scrollDirection = options.scrollDirection, slideAnimation = options.slideAnimation;
        return (scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL &&
            slideAnimation !== GALLERY_CONSTS.slideAnimations.SCROLL);
    };
    GalleryContainer.prototype.getVisibleItems = function (items, container, isPrerenderMode) {
        var _a, _b;
        var gotFirstScrollEvent = this.state.gotFirstScrollEvent;
        var scrollY = ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.scrollPosition) === null || _b === void 0 ? void 0 : _b.top) || 0;
        var galleryHeight = container.galleryHeight, scrollBase = container.scrollBase, galleryWidth = container.galleryWidth;
        if (isPrerenderMode || // (used to be isSSR, had a hydrate bug, isPrerenderMode is the way to go in terms of hydrate issues)
            isSEOMode() ||
            isEditMode() ||
            gotFirstScrollEvent ||
            scrollY > 0 || // Can be an inner container with its own scroll
            window.scrollY > 0 ||
            isPreviewMode() ||
            this.props.activeIndex > 0) {
            return items;
        }
        var visibleItems = items;
        try {
            var windowHeight = window.innerHeight;
            var isInfinite = this.isVerticalGallery() &&
                this.containerInfiniteGrowthDirection() === 'vertical';
            var galleryBottom = isInfinite ? Infinity : scrollBase + galleryHeight;
            var windowBottom = scrollY + windowHeight;
            var maxItemTop_1 = Math.min(galleryBottom, windowBottom) - scrollBase;
            if (maxItemTop_1 < 0) {
                //gallery is below the fold
                visibleItems = [];
            }
            else if (this.isVerticalGallery()) {
                visibleItems = items.filter(function (item) { return item.offset.top < maxItemTop_1; });
            }
            else {
                visibleItems = items.filter(function (item) { return item.left <= galleryWidth + 20; });
            }
            if (visibleItems.length < 2 && visibleItems.length < items.length) {
                //dont render less then 2 items (otherwise slide show Arrow will be removed)
                visibleItems = items.slice(0, 2);
            }
        }
        catch (e) {
            console.error('Could not calculate visible items, returning original items', e);
            visibleItems = items;
        }
        return visibleItems;
    };
    GalleryContainer.prototype.propsToState = function (_a) {
        var items = _a.items, options = _a.options, structure = _a.structure, container = _a.container, id = _a.id, createMediaUrl = _a.createMediaUrl, isPrerenderMode = _a.isPrerenderMode;
        items = items || this.props.items;
        options = options || this.props.options;
        container = container || this.props.container;
        structure = structure || this.props.structure;
        id = id || this.props.id;
        createMediaUrl = createMediaUrl || this.props.createMediaUrl;
        this.galleryStructure = ItemsHelper.convertToGalleryItems(structure, {
            // TODO use same objects in the memory when the galleryItems are changed
            thumbnailSize: options.thumbnailSize,
            sharpParams: options.sharpParams,
            createMediaUrl: createMediaUrl,
        });
        // // ------------ TODO. This is using GalleryItem and I am leaving it here for now ---------- //
        var shouldUseScrollCss = !isSEOMode() &&
            (isEditMode() ||
                this.state.gotFirstScrollEvent ||
                this.state.showMoreClickedAtLeastOnce);
        if (shouldUseScrollCss) {
            this.getScrollCss({
                id: id,
                items: this.galleryStructure.galleryItems,
                options: options,
                container: container,
            });
        }
        var layoutParams = {
            items: items,
            container: container,
            styleParams: options,
            gotScrollEvent: true,
            options: {
                showAllItems: true,
                skipVisibilitiesCalc: true,
                useLayoutStore: false,
                createLayoutOnInit: false,
            },
        };
        this.createCssLayoutsIfNeeded(layoutParams);
        this.createDynamicStyles(options, isPrerenderMode);
        var newState = {
            items: items,
            options: options,
            container: container,
            structure: structure,
        };
        return newState;
    };
    GalleryContainer.prototype.getScrollingElement = function () {
        var _this = this;
        var horizontal = function () {
            return window.document.querySelector("#pro-gallery-".concat(_this.props.id, " #gallery-horizontal-scroll-").concat(_this.props.id));
        };
        var vertical = this.props.scrollingElement
            ? function () { return _this.props.scrollingElement; }
            : function () { return window; };
        return { vertical: vertical, horizontal: horizontal };
    };
    GalleryContainer.prototype.scrollToItem = function (itemIdx, fixedScroll, isManual, durationInMS, scrollMarginCorrection, isContinuousScrolling) {
        var _this = this;
        if (durationInMS === void 0) { durationInMS = 0; }
        if (isContinuousScrolling === void 0) { isContinuousScrolling = false; }
        if (itemIdx >= 0) {
            if (!this.state.gotFirstScrollEvent) {
                this.setState({
                    gotFirstScrollEvent: true,
                });
            }
            if (this.getIsScrollLessGallery(this.state.options)) {
                return;
            }
            var scrollingElement = this._scrollingElement;
            var horizontalElement = scrollingElement.horizontal();
            try {
                var scrollParams = {
                    scrollMarginCorrection: scrollMarginCorrection,
                    isRTL: this.state.options.isRTL,
                    scrollDirection: this.state.options.scrollDirection,
                    galleryWidth: this.state.container.galleryWidth,
                    galleryHeight: this.state.container.galleryHeight,
                    top: 0,
                    items: this.galleryStructure.items,
                    totalWidth: this.galleryStructure.width,
                    itemIdx: itemIdx,
                    fixedScroll: fixedScroll,
                    isManual: isManual,
                    scrollingElement: scrollingElement,
                    horizontalElement: horizontalElement,
                    durationInMS: durationInMS,
                    slideTransition: this.state.options.slideTransition,
                    isContinuousScrolling: isContinuousScrolling,
                    autoSlideshowContinuousSpeed: this.state.options.autoSlideshowContinuousSpeed,
                    imageMargin: this.state.options.imageMargin,
                };
                this.currentScrollData = scrollToItemImp(scrollParams);
                return this.currentScrollData.scrollDeffered.promise.then(function () {
                    _this.currentScrollData = null;
                });
            }
            catch (e) {
                //added console.error to debug sentry error 'Cannot read property 'isRTL' of undefined in pro-gallery-statics'
                console.error('error:', e, ' pro-gallery, scrollToItem, cannot get scrollParams, ', 'isEditMode =', isEditMode(), ' isPreviewMode =', isPreviewMode(), ' isSiteMode =', isSiteMode(), ' this.state.options =', this.state.options, ' this.state.container =', this.state.container, ' this.galleryStructure =', this.galleryStructure);
            }
        }
    };
    GalleryContainer.prototype.scrollToGroup = function (groupIdx, fixedScroll, isManual, durationInMS, scrollMarginCorrection, isContinuousScrolling) {
        var _this = this;
        if (durationInMS === void 0) { durationInMS = 0; }
        if (isContinuousScrolling === void 0) { isContinuousScrolling = false; }
        if (groupIdx >= 0) {
            var scrollingElement = this._scrollingElement;
            var horizontalElement = scrollingElement.horizontal();
            try {
                var scrollParams = {
                    scrollMarginCorrection: scrollMarginCorrection,
                    isRTL: this.state.options.isRTL,
                    scrollDirection: this.state.options.scrollDirection,
                    galleryWidth: this.state.container.galleryWidth,
                    galleryHeight: this.state.container.galleryHeight,
                    top: 0,
                    groups: this.galleryStructure.groups,
                    totalWidth: this.galleryStructure.width,
                    groupIdx: groupIdx,
                    fixedScroll: fixedScroll,
                    isManual: isManual,
                    scrollingElement: scrollingElement,
                    horizontalElement: horizontalElement,
                    durationInMS: durationInMS,
                    slideTransition: this.state.options.slideTransition,
                    isContinuousScrolling: isContinuousScrolling,
                    autoSlideshowContinuousSpeed: this.state.options.autoSlideshowContinuousSpeed,
                    imageMargin: this.state.options.imageMargin,
                };
                this.currentScrollData = scrollToGroupImp(scrollParams);
                return this.currentScrollData.scrollDeffered.promise.then(function () {
                    _this.currentScrollData = null;
                });
            }
            catch (e) {
                //added console.error to debug sentry error 'Cannot read property 'isRTL' of undefined in pro-gallery-statics'
                console.error('error:', e, ' pro-gallery, scrollToGroup, cannot get scrollParams, ', 'isEditMode =', isEditMode(), ' isPreviewMode =', isPreviewMode(), ' isSiteMode =', isSiteMode(), ' this.state.options =', this.state.options, ' this.state.container =', this.state.container, ' this.galleryStructure =', this.galleryStructure);
            }
        }
    };
    GalleryContainer.prototype.containerInfiniteGrowthDirection = function (options) {
        if (options === void 0) { options = false; }
        var _options = options || this.props.options;
        // return the direction in which the gallery can grow on it's own (aka infinite scroll)
        var enableInfiniteScroll = this.props.options.enableInfiniteScroll; //TODO - props or "raw" options
        var showMoreClickedAtLeastOnce = this.state.showMoreClickedAtLeastOnce;
        var scrollDirection = _options.scrollDirection, loadMoreAmount = _options.loadMoreAmount;
        if (scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL) {
            return 'horizontal';
        }
        else if (!enableInfiniteScroll) {
            //vertical gallery with showMore button enabled
            if (showMoreClickedAtLeastOnce && loadMoreAmount === 'all') {
                return 'vertical';
            }
            else {
                return 'none';
            }
        }
        else {
            return 'vertical';
        }
    };
    GalleryContainer.prototype.setPlayingIdxState = function (playingVideoIdx) {
        this.setState({
            playingVideoIdx: playingVideoIdx,
        });
    };
    GalleryContainer.prototype.onGalleryScroll = function (scrollPosition) {
        if (this.props.isInDisplay) {
            this.eventsListener(GALLERY_CONSTS.events.GALLERY_SCROLLED, scrollPosition);
        }
    };
    GalleryContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        // in order to update when container is available
        this.setVisibilityIfNeeded(prevProps, prevState);
        if (this.props.isPrerenderMode !== prevProps.isPrerenderMode) {
            var body = document.body, html = document.documentElement;
            var viewportHeight = window.innerHeight;
            var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            this.getMoreItemsIfScrollIsDisabled(height, viewportHeight);
        }
    };
    GalleryContainer.prototype.createDynamicStyles = function (_a, isPrerenderMode) {
        var _b, _c;
        var overlayBackground = _a.overlayBackground;
        var useSSROpacity = isPrerenderMode && !this.props.settings.disableSSROpacity;
        var prerenderSelectors = "#pro-gallery-".concat(this.props.id, " .gallery-item-container");
        // Add thumbnails selector if thumbnails are enabled
        if (((_b = this.props.options) === null || _b === void 0 ? void 0 : _b.hasThumbnails) &&
            ((_c = this.props.options) === null || _c === void 0 ? void 0 : _c.scrollDirection) ===
                GALLERY_CONSTS.scrollDirection.HORIZONTAL) {
            prerenderSelectors += ", #pro-gallery-".concat(this.props.id, " .thumbnails-gallery");
        }
        this.dynamicStyles = "\n      ".concat(!useSSROpacity ? '' : "".concat(prerenderSelectors, " { opacity: 0 }"), "\n      ").concat(!overlayBackground
            ? ''
            : "#pro-gallery-".concat(this.props.id, " .gallery-item-hover::before { background: ").concat(overlayBackground, " !important}"), "\n    ").trim();
    };
    GalleryContainer.prototype.createCssLayoutsIfNeeded = function (layoutParams) {
        var _a = this.props.settings, settings = _a === void 0 ? {} : _a;
        var avoidInlineStyles = settings.avoidInlineStyles;
        if (avoidInlineStyles) {
            this.layoutCss = createCssLayouts({
                layoutParams: layoutParams,
                isMobile: utils.isMobile(),
                id: this.props.id,
                galleryItems: this.galleryStructure.galleryItems,
            });
        }
    };
    GalleryContainer.prototype.getScrollCss = function (_a) {
        var id = _a.id, items = _a.items, options = _a.options, container = _a.container;
        this.scrollCss = cssScrollHelper.calcScrollCss({
            items: items,
            options: options,
            id: id,
            container: container,
        });
    };
    GalleryContainer.prototype.toggleLoadMoreItems = function () {
        var _this = this;
        this.eventsListener(GALLERY_CONSTS.events.LOAD_MORE_CLICKED, this.galleryStructure.galleryItems);
        var showMoreClickedAtLeastOnce = true;
        var needToHandleShowMoreClick = true;
        //before clicking "load more" at the first time
        if (!this.state.showMoreClickedAtLeastOnce) {
            this.getScrollCss({
                id: this.props.id,
                items: this.galleryStructure.galleryItems,
                options: this.state.options,
                container: this.state.container,
            });
            var initialGalleryHeight = this.state.container.height; //container.height before clicking "load more" at the first time
            this.setState({
                showMoreClickedAtLeastOnce: showMoreClickedAtLeastOnce,
                initialGalleryHeight: initialGalleryHeight,
                needToHandleShowMoreClick: needToHandleShowMoreClick,
            }, function () {
                _this.handleNewGalleryStructure();
            });
        }
        else {
            //from second click
            this.setState({
                needToHandleShowMoreClick: needToHandleShowMoreClick,
            }, function () {
                _this.handleNewGalleryStructure();
            });
        }
    };
    GalleryContainer.prototype.setGotFirstScrollIfNeeded = function () {
        if (!this.state.gotFirstScrollEvent) {
            this.getScrollCss({
                id: this.props.id,
                items: this.galleryStructure.galleryItems,
                options: this.state.options,
                container: this.state.container,
            });
            this.setState({
                gotFirstScrollEvent: true,
            });
        }
    };
    GalleryContainer.prototype.setCurrentSlideshowViewIdx = function (idx) {
        this.currentSlideshowViewIdx = idx;
    };
    GalleryContainer.prototype.simulateHorizontalScrollToItem = function (item) {
        (item === null || item === void 0 ? void 0 : item.offset) && this.onGalleryScroll({ left: item.offset.left });
    };
    GalleryContainer.prototype.eventsListener = function (eventName, eventData, event) {
        var _this = this;
        this.videoScrollHelper.handleEvent({
            eventName: eventName,
            eventData: eventData,
        });
        if (eventName === GALLERY_CONSTS.events.HOVER_SET) {
            this.currentHoverChangeEvent.currentHoverIdx = eventData;
            window.dispatchEvent(this.currentHoverChangeEvent);
        }
        if (eventName === GALLERY_CONSTS.events.CURRENT_ITEM_CHANGED) {
            this.setCurrentSlideshowViewIdx(eventData.idx);
            if (this.getIsScrollLessGallery(this.state.options) &&
                this.state.firstUserInteractionExecuted) {
                this.simulateHorizontalScrollToItem(this.galleryStructure.items[eventData.idx]);
            }
        }
        if (!this.state.firstUserInteractionExecuted) {
            switch (eventName) {
                case GALLERY_CONSTS.events.HOVER_SET:
                case GALLERY_CONSTS.events.LOAD_MORE_CLICKED:
                case GALLERY_CONSTS.events.ITEM_ACTION_TRIGGERED:
                    this.setState({ firstUserInteractionExecuted: true });
                    break;
            }
        }
        if (typeof this.props.eventsListener === 'function') {
            switch (eventName) {
                case GALLERY_CONSTS.events.ITEM_ACTION_TRIGGERED:
                case GALLERY_CONSTS.events.ITEM_CLICKED:
                    setTimeout(function () {
                        _this.props.eventsListener(eventName, eventData, event);
                    }, 0);
                    break;
                default:
                    this.props.eventsListener(eventName, eventData, event);
            }
        }
        if (eventName === GALLERY_CONSTS.events.GALLERY_SCROLLED) {
            this.videoScrollHelper.trigger.SCROLL(eventData);
            var newScrollPosition = __assign(__assign({}, this.state.scrollPosition), eventData);
            this.setState({ scrollPosition: newScrollPosition });
        }
    };
    /**
     * Check if we should skip waiting for the scroll position to be updated.
     * This is needed to avoid flickering with auto-slideshow (PG-1152).
     * @returns {boolean}
     */
    GalleryContainer.prototype.shouldSkipWaitingScrollPos = function () {
        var _a, _b;
        var _c = ((_a = this.state) === null || _a === void 0 ? void 0 : _a.options) || {}, scrollDirection = _c.scrollDirection, isRTL = _c.isRTL;
        var isHorizontal = scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL;
        var userAgent = (typeof window !== 'undefined' && ((_b = window.navigator) === null || _b === void 0 ? void 0 : _b.userAgent)) || '';
        var isSafari = userAgent.indexOf('Safari') > -1 &&
            userAgent.indexOf('Chrome') === -1 &&
            userAgent.indexOf('Chromium') === -1;
        var isChromeMobile = (userAgent.indexOf('Chrome') > -1 || userAgent.indexOf('CriOS') > -1) &&
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
        var isSafariOrChromeMobile = isSafari || isChromeMobile;
        return isHorizontal && isSafariOrChromeMobile && isRTL;
    };
    GalleryContainer.prototype.getMoreItemsIfNeeded = function (scrollPos) {
        var _this = this;
        var _a;
        var shouldSkipWaitingScrollPos = this.shouldSkipWaitingScrollPos();
        if ((_a = this.deferredGettingMoreItems) === null || _a === void 0 ? void 0 : _a.isPending) {
            // Already getting more items so just remember the scroll position.
            // Skip for Safari/Chrome Mobile to avoid flickering with auto-slideshow (PG-1152).
            if (!shouldSkipWaitingScrollPos) {
                this.latestScrollPosWhileBlocked = scrollPos;
            }
        }
        else {
            this.deferredGettingMoreItems = new Deferred();
            if (!(this.galleryStructure &&
                this.galleryStructure.galleryItems &&
                this.galleryStructure.galleryItems.length > 0 &&
                this.state.items &&
                this.state.options &&
                this.state.container)) {
                // No items are fetched -> reject
                this.deferredGettingMoreItems.reject();
            }
            else {
                //more items can be fetched from the server
                //TODO - add support for horizontal galleries
                var scrollDirection = this.state.options.scrollDirection;
                var galleryEnd = this.galleryStructure[scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL
                    ? 'width'
                    : 'height'] +
                    (scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL
                        ? 0
                        : this.state.container.scrollBase);
                var screenSize = window[scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL
                    ? 'innerWidth'
                    : 'innerHeight'];
                var scrollEnd = scrollPos + screenSize;
                var getItemsDistance = scrollPos ? 3 * screenSize : 0; //first scrollPos is 0 falsy. dont load before a scroll happened.
                if (galleryEnd < getItemsDistance + scrollEnd) {
                    //only when the last item turns visible we should try getting more items
                    this.eventsListener(GALLERY_CONSTS.events.NEED_MORE_ITEMS, this.state.items.length);
                    setTimeout(function () {
                        //wait a bit before allowing more items to be fetched - ugly hack before promises still not working
                        _this.deferredGettingMoreItems.resolve();
                        if (_this.latestScrollPosWhileBlocked !== undefined &&
                            !shouldSkipWaitingScrollPos) {
                            var capturedPos = _this.latestScrollPosWhileBlocked;
                            _this.latestScrollPosWhileBlocked = undefined; // Clear it
                            _this.getMoreItemsIfNeeded(capturedPos);
                        }
                    }, 500);
                }
                else {
                    // No items are fetched -> reject
                    this.deferredGettingMoreItems.reject();
                }
            }
        }
        return this.deferredGettingMoreItems.promise.catch(function () { });
    };
    GalleryContainer.prototype.canRender = function () {
        var can = this.props.container && this.props.options && this.state.items;
        if (!can && utils.isVerbose()) {
            console.log('PROGALLERY [CAN_RENDER] GalleryContainer', can, this.props.container, this.props.options, this.state.items);
        }
        return can;
    };
    GalleryContainer.prototype.onMouseEnter = function () {
        var _a;
        if (((_a = this.currentScrollData) === null || _a === void 0 ? void 0 : _a.isContinuousScrolling) &&
            this.state.options.pauseAutoSlideshowOnHover) {
            haltScroll(this.currentScrollData);
        }
        this.setState({ isInHover: true });
    };
    GalleryContainer.prototype.onMouseLeave = function () {
        this.setState({ isInHover: false });
    };
    GalleryContainer.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        if (!this.canRender()) {
            return null;
        }
        var ViewComponent = this.props.options.scrollDirection ===
            GALLERY_CONSTS.scrollDirection.HORIZONTAL
            ? SlideshowView
            : GalleryView;
        if (utils.isVerbose()) {
            console.count('PROGALLERY [COUNTS] - GalleryContainer (render)');
            console.log('PROGALLERY [RENDER] - GalleryContainer', this.props.container.scrollBase, { props: this.props, items: this.state.items });
        }
        var displayShowMore = this.containerInfiniteGrowthDirection() === 'none';
        return (React.createElement("div", { "data-key": "pro-gallery-inner-container", key: "pro-gallery-inner-container", className: this.props.isPrerenderMode ? 'pro-gallery-prerender' : '', onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, ref: function (e) { return (_this.galleryContainerRef = e); }, tabIndex: -1 },
            React.createElement(ScrollIndicator, { id: this.props.id, scrollDirection: this.props.options.scrollDirection, isRTL: this.props.options.isRTL, totalWidth: this.galleryStructure.width, scrollBase: this.props.container.scrollBase, scrollingElement: this._scrollingElement, getMoreItemsIfNeeded: this.getMoreItemsIfNeeded, setGotFirstScrollIfNeeded: this.setGotFirstScrollIfNeeded, onScroll: this.onGalleryScroll }),
            React.createElement(ViewComponent, __assign({ isInDisplay: this.props.isInDisplay, isInViewport: this.state.isInViewport, isPrerenderMode: this.props.isPrerenderMode, scrollingElement: this._scrollingElement, totalItemsCount: this.props.totalItemsCount, renderedItemsCount: this.props.renderedItemsCount, getMoreItemsIfNeeded: this.getMoreItemsIfNeeded, gotFirstScrollEvent: this.state.gotFirstScrollEvent, setGotFirstScrollIfNeeded: this.setGotFirstScrollIfNeeded, items: this.state.items, getVisibleItems: this.getVisibleItems, galleryStructure: this.galleryStructure, options: this.props.options, container: this.props.container, settings: this.props.settings, displayShowMore: displayShowMore, id: this.props.id, activeIndex: this.props.activeIndex || 0, customComponents: this.props.customComponents, playingVideoIdx: this.state.playingVideoIdx, noFollowForSEO: this.props.noFollowForSEO, proGalleryRegionLabel: this.props.proGalleryRegionLabel, proGalleryRole: this.props.proGalleryRole, firstUserInteractionExecuted: this.state.firstUserInteractionExecuted, isGalleryInHover: this.state.isInHover, enableExperimentalFeatures: this.props.enableExperimentalFeatures, galleryContainerRef: this.galleryContainerRef, outOfViewComponent: this.outOfViewComponent, virtualizationSettings: this.props.virtualizationSettings, galleryContainerId: "pro-gallery-container-".concat(this.props.id), scrollTop: (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.scrollPosition) === null || _b === void 0 ? void 0 : _b.top, isScrollLessGallery: this.getIsScrollLessGallery(this.state.options), shouldDisableItemFocus: this.props.shouldDisableItemFocus, experimentalFeatures: this.props.experimentalFeatures, actions: __assign(__assign({}, this.props.actions), { findNeighborItem: this.findNeighborItem, toggleLoadMoreItems: this.toggleLoadMoreItems, eventsListener: this.eventsListener, setWixHeight: function () { }, scrollToItem: this.scrollToItem, scrollToGroup: this.scrollToGroup }) }, this.props.gallery)),
            React.createElement("div", { "data-key": "items-styles", key: "items-styles", style: { display: 'none' } },
                (this.layoutCss || []).filter(Boolean).map(function (css, idx) { return (React.createElement("style", { id: "layoutCss-".concat(idx), key: "layoutCss-".concat(idx), dangerouslySetInnerHTML: { __html: css } })); }),
                (this.scrollCss || []).filter(Boolean).map(function (css, idx) { return (React.createElement("style", { id: "scrollCss_".concat(idx), key: "scrollCss_".concat(idx), dangerouslySetInnerHTML: { __html: css } })); }),
                !!this.dynamicStyles && (React.createElement("style", { dangerouslySetInnerHTML: { __html: this.dynamicStyles } }))),
            this.props.proGalleryRole === 'application' && (React.createElement("span", { ref: function (e) { return (_this.outOfViewComponent = e); }, tabIndex: -1, className: "sr-only out-of-view-component" }, (_c = this.props.translations) === null || _c === void 0 ? void 0 : _c.Accessibility_Left_Gallery))));
    };
    return GalleryContainer;
}(React.Component));
export { GalleryContainer };
export default GalleryContainer;
/* eslint-enable prettier/prettier */
//# sourceMappingURL=galleryContainer.js.map